"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
(function () {
    if (window.hasOwnProperty("config") && window["config"].hasOwnProperty("user") && window["config"]["user"]["LoggedIn"] === true) {
        var returnUrl = l.UrlUtility.getUrlParam("ReturnUrl");
        if (returnUrl) {
            returnUrl = returnUrl.replace(/^https?/i, "https");
            var realmDetails = l.Common.getRealmsDetail();
            var inMainSiteUrl = false;
            var keys = Object.keys(realmDetails);
            var anchor = document.createElement("a");
            anchor.href = returnUrl;
            var returnUrlHost = anchor.host;
            for (var i = 0; i < keys.length; i++) {
                var defaultUrl = realmDetails[i].defaultSiteUrl;
                anchor.href = defaultUrl;
                if (anchor.host && anchor.host.toLowerCase() === returnUrlHost.toLowerCase()) {
                    inMainSiteUrl = true;
                }
            }
            if (inMainSiteUrl)
                window.location.href = returnUrl;
        }
    }
})();
